<template>
  <div class="h-full shadow-md bg-white dark:bg-dark-400" style="border-radius: 1rem">
    <div class="w-full h-full">
      <VueApexCharts
        class="pt-2 mx-4"
        height="95%"
        :options="chartOptions"
        :series="heatMapPresenter.heatMapSeries.value"
        type="heatmap"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useHeatMapPresenter } from '@/presentation/composables/dashboard/useHeatMapPresenter'
import { getHeatMapOptions } from '@/util/dashboard/heatMapOptions'

export default defineComponent({
  components: {
    VueApexCharts
  },
  setup(props, ctx) {
    const heatMapPresenter = useHeatMapPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const chartOptions = getHeatMapOptions(heatMapPresenter.heatMapXLabel.value, isLightMode(), displayLanguage.value)

    return {
      chartOptions,
      heatMapPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
